import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Consulta } from 'src/app/models/consulta';
import { ConsultaComposta } from 'src/app/models/consulta-composta';
import { map } from 'rxjs/operators';
import { generateIdempotencyKey } from 'src/app/utils/idempotency-key.util';

@Injectable({
  providedIn: 'root'
})
export class RealizarConsultaService {

  constructor(private httpClient: HttpClient) { }

  private buildIdempotencyHeaders(idempotencyKey?: string) {
    return {
      headers: {
        'Idempotency-Key': idempotencyKey || generateIdempotencyKey('fazer-consulta'),
      },
    };
  }


  realizarConsulta(data, idempotencyKey?: string) {
    return this.httpClient
      .post(environment.wsUrl + 'fazerConsulta', data, this.buildIdempotencyHeaders(idempotencyKey))
      .toPromise();
  }


  verificaConsulta(data, idempotencyKey?: string) {
    return this.httpClient
      .post<any>(
        environment.wsUrl + 'fazerConsulta/verificaConsulta',
        data,
        this.buildIdempotencyHeaders(idempotencyKey)
      )
      .toPromise();
  }

  enviarConsultaLote(tipoConsulta, arquivo): Promise<{ 'msg': String, 'erro': boolean }> {
    let form = new FormData();
    form.append('tipoConsulta', tipoConsulta);
    form.append('uploadFile', arquivo);
    return this.httpClient.post<{ 'msg': String, 'erro': boolean }>(environment.wsUrl + 'consultaLote/uploadConsultaLote', form, {
    //  headers: {'Content-Type' : 'multipart/form-data'}
    }).toPromise();
  }

  listarConsultaLote(params) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }

    return this.httpClient.post<{ total: number, lista: { dataCriacao: string, nome: string, id: number }[] }>
    (environment.wsUrl + 'consultaLote/getListaConsultaLote/', data, {}).pipe().toPromise();
  }

  resultadoConsultaLote(id, params, ignore = ['loading']) {
    let data = { ...params };
    data.sorting = {};

    for (const i in params.sorting) {
      if (params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }

    return this.httpClient.post<{
        labelEntrada: string,
        lista: [{ entrada: string, status: string, codigoStatus: number, dataConsula: string }],
        nome: string,
        qtdFinalizado: number,
        qtdPendente: number,
        qtdProcessado: number,
        total: number,
      }>(environment.wsUrl + 'consultaLote/getConsultaLote/' + id, data).pipe().toPromise();
  }


  downloadLote(id,ignore = ['content-type']){
    let body = {idLote:id};
    return this.httpClient.post(environment.wsUrl + 'consultaLote/downloadLote' ,body, {
      params: { ignore: ignore }, responseType: 'blob'
    }).toPromise();
  }

  executaLote(id, ignore = []){
    let body = {id:id};
    return this.httpClient.post(environment.wsUrl + 'consultaLote/executaLote' ,body, {
      params: { ignore: ignore }
    }).toPromise();
  }

  editarConsulta(data) {
    return this.httpClient.post(environment.wsUrl + 'consultaVeiculo/editarConsulta', data).toPromise();
  }

}
